import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css``,
  tag: css`
    padding: 2px 8px;
    border-radius: ${pxToRem(10)};
    gap: 4px;
    font-family: 'Montserrat Medium';
    font-size: ${pxToRem(12)};
    line-height: 1.33;
    letter-spacing: -0.3px;
    display: inline-flex;
    align-items: center;
    height: ${pxToRem(24)};
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    width: fit-content;
  `,
  clickable: css`
    cursor: pointer;
  `,
  variants: {
    new: css`
      color: ${colors.jungle};
      background: ${colors.mint};
    `,
    greyOutline: css`
      color: ${colors.white};
      background: ${colors.slate};
    `,
    startDate: css`
      color: ${colors.prussian};
      background: ${colors.prussian300};
    `,
    outline: css`
      border: 1px solid ${colors.prussianMid};
      color: ${colors.prussian};
      background: transparent;
    `,
    expired: css`
      color: ${colors.dragon};
      background: ${colors.dragon200};
      border: 1px solid ${colors.dragon200};
    `,
    deadline: css`
      color: ${colors.orange800};
      background: ${colors.orange100};
    `,
    timeline: css`
      color: ${colors.charcoal};
      background: ${colors.platinum};
    `,
    filled: css`
      color: ${colors.white};
      background: ${colors.prussian};
      height: ${pxToRem(24)};
    `,
    beta: css`
      background: ${colors.peach100};
      color: ${colors.soil};
      padding: 4px 12px !important;
      font-weight: 500;
    `,
    viewed: css`
      background: ${colors.platinum};
      color: ${colors.midnight};
      opacity: 0.9;
    `,
    community: css`
      color: ${colors.white};
      background: ${colors.prussianMid};
      height: ${pxToRem(24)};
    `,
    free: css`
      color: ${colors.prussian700};
      background: ${colors.peach200};
    `,
    active: css`
      color: ${colors.prussian};
      background: ${colors.jungle100};
      border: 1px solid ${colors.jungle};
    `,
  },
};

export default styles;
